import { useGlobalConfigContext } from '../../../global-config'
import { TENANT } from '../../../tenant'
import { productAccessorIsProductNotInCatalog } from '../../model/productAccessor/productAccessorIsProductNotInCatalog'
import { productAccessorIsProductOutOfSale } from '../../model/productAccessor/productAccessorIsProductOutOfSale'
import { productAccessorIsProductOutOfStock } from '../../model/productAccessor/productAccessorIsProductOutOfStock'
import { PRODUCT_TEMPLATES } from '../../model/productTemplates'
import { useProductAddToCartCtaShouldShowSelectErxModal } from '../ProductBuyBox/ProductAddToCartGroup/ProductAddToCartCta/useProductAddToCartCtaShouldShowSelectErxModal'
import { useProductPageContext } from '../productPageContext'

/** Identifies available COM Rx products that support app redemption. */
export const useProductAppRedemptionEligibility = (): boolean => {
  const { tenant } = useGlobalConfigContext()
  const { currentVariant, followUpProduct, product, productTemplate } =
    useProductPageContext()
  const shouldOpenPrescriptionRedemption =
    useProductAddToCartCtaShouldShowSelectErxModal()

  return (
    tenant === TENANT.COM &&
    productTemplate === PRODUCT_TEMPLATES.RX &&
    shouldOpenPrescriptionRedemption &&
    !productAccessorIsProductOutOfStock(currentVariant.stock_status) &&
    !productAccessorIsProductNotInCatalog(currentVariant.stock_status) &&
    (!productAccessorIsProductOutOfSale(product.stock_status) ||
      !followUpProduct?.canonical_url)
  )
}
